import { render } from "./ChicagoMag.vue?vue&type=template&id=3c036e48&scoped=true"
import script from "./ChicagoMag.vue?vue&type=script&lang=js"
export * from "./ChicagoMag.vue?vue&type=script&lang=js"

import "./ChicagoMag.vue?vue&type=style&index=0&id=3c036e48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c036e48"]])

export default __exports__